// extracted by mini-css-extract-plugin
export var chevronIcon = "_a9-2";
export var teamName = "_a9-1";
export var teamSwitcherButton = "_a9-0";